import {
  SideNavLogoutIcn,
  SideNavPasswordIcn,
  SideNavUserProfileIcn,
  SideNavPrivacyIcn,
} from 'components/Icons'
import React from 'react'
import styles from './accountSideNav.module.scss'
import SideNavItem, { SideNavItemProps } from './SideNavItem'
import useWindowSize from '../../hooks/use-windowSize'
import { TABLET_BREAKPOINT } from 'constants/global'
import i18n from 'constants/strings'
import { getSignOutUrl } from 'utils'
import { MyAccountSections } from 'constants/my-account'

interface Props {
  activeTab: number
  onTabClick: (section: string) => void
}

const AccountSideNav = ({ activeTab, onTabClick }: Props) => {
  const windowWidth = useWindowSize().width
  const TABS: SideNavItemProps[] = [
    {
      icon: <SideNavUserProfileIcn />,
      copy: i18n.t('strMyAccount.myDetails'),
      onClick: () => {
        onTabClick(MyAccountSections.MY_DETAILS)
      },
    },
    {
      icon: <SideNavPrivacyIcn />,
      copy: i18n.t('strMyAccount.privacyAndConsents.title'),
      onClick: () => {
        onTabClick(MyAccountSections.PRIVACY_AND_CONSENTS)
      },
    },
    {
      icon: <SideNavPasswordIcn />,
      copy: i18n.t('strMyAccount.signInDetails.title'),
      onClick: () => {
        onTabClick(MyAccountSections.SIGN_IN_DETAILS)
      },
    },
  ]

  return (
    <>
      {windowWidth && windowWidth >= TABLET_BREAKPOINT ? (
        <div className={styles.sideNav}>
          <div className={styles.heading}>
            <span>Menu</span>
          </div>
          {TABS.map((tab, index) => (
            <SideNavItem key={index} active={index === activeTab} {...tab} />
          ))}
          <hr></hr>
          <SideNavItem
            icon={<SideNavLogoutIcn />}
            copy={i18n.t('strMyAccount.logout')}
            external
            href={getSignOutUrl()}
          />
        </div>
      ) : null}
    </>
  )
}

export default AccountSideNav
